import React from "react";

function GamesPage() {
  return (
    <div>
      <h2>All Games</h2>
      <p>Here is a list of all available games.</p>
      {/* You can map through your game list here later */}
    </div>
  );
}

export default GamesPage;
